export default __webpack_public_path__ + "static/media/Bell.1f4bb231.svg";